import { createContext, type ReactNode, useContext, useState } from 'react';

interface CommandPaletteState {
	isOpen: boolean;
	setOpen: (open: boolean) => void;
	toggle: () => void;
}

const CommandPaletteContext = createContext<CommandPaletteState | undefined>(undefined);

export function CommandPaletteProvider({ children }: { children: ReactNode }) {
	const [isOpen, setOpen] = useState(false);
	const toggle = () => setOpen((prev) => !prev);

	return (
		<CommandPaletteContext.Provider value={{ isOpen, setOpen, toggle }}>{children}</CommandPaletteContext.Provider>
	);
}

export function useCommandPaletteStore() {
	const context = useContext(CommandPaletteContext);
	if (!context) {
		throw new Error('useCommandPaletteStore must be used within a CommandPaletteProvider');
	}
	return context;
}
